module.exports = {
      id: "ic-time-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-time-usage",
      toString: function () {
        return this.url;
      }
    }